/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { McpMetadata, McpMetadata$inboundSchema } from "./mcpmetadata.js";

export type GetMcpMetadataResponseBody = {
  /**
   * Metadata used to configure the MCP install page. toolset_id or mcp_server_id identifies which backend the metadata belongs to; a hosted MCP server with a live canonical MCP server carries both, set to the same id.
   */
  metadata?: McpMetadata | undefined;
};

/** @internal */
export const GetMcpMetadataResponseBody$inboundSchema: z.ZodMiniType<
  GetMcpMetadataResponseBody,
  unknown
> = z.object({
  metadata: z.optional(McpMetadata$inboundSchema),
});

export function getMcpMetadataResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetMcpMetadataResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMcpMetadataResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMcpMetadataResponseBody' from JSON`,
  );
}
